import styles from "./RadialTargetGraph.module.css";
import { memo } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { formatPercent } from "../utils/formatPercent";

const CHART_PADDING = 16;
const CHART_LABEL_HEIGHT = 32;
const CHART_HEIGHT = 170;
const CHART_WIDTH = 300;

export const RadialTargetGraph = memo(
  ({ title, value = 0, target = null, max = 1 }) => {
    const percent = value * 100;
    const maxPercent = max * 100;

    const radius = CHART_WIDTH / 2;
    const dashOffset =
      ((maxPercent - percent) / maxPercent) * (Math.PI * radius);

    return (
      <div className={styles.container}>
        <div className={styles.labels}>
          <span className={styles.valueLabel}>{formatPercent(percent)}</span>
          <span className={styles.titleLabel}>{title}</span>
        </div>

        <svg
          className={styles.graph}
          xmlns="http://www.w3.org/2000/svg"
          viewBox={`0 0 ${CHART_WIDTH} ${CHART_HEIGHT + CHART_LABEL_HEIGHT}`}
        >
          <mask id="circleMask">
            <rect
              x={0}
              y={0}
              width={CHART_WIDTH}
              height={CHART_HEIGHT}
              fill="white"
            />
          </mask>

          <circle
            className={styles.halfCircle}
            cx={CHART_WIDTH / 2}
            cy={CHART_HEIGHT}
            r={(CHART_WIDTH - CHART_PADDING * 2) / 2}
            mask="url(#circleMask)"
          />

          <circle
            className={styles.halfCircleFill}
            cx={CHART_WIDTH / 2}
            cy={CHART_HEIGHT}
            r={(CHART_WIDTH - CHART_PADDING * 2) / 2}
            style={{
              "--dashOffset": dashOffset + "px",
            }}
            mask="url(#circleMask)"
          />

          <text
            x={CHART_PADDING - 8}
            y={CHART_HEIGHT + CHART_PADDING}
            textLength={17}
            style={{ textAlign: "center" }}
          >
            0
          </text>

          <text
            x={CHART_WIDTH - CHART_PADDING - 8}
            y={CHART_HEIGHT + CHART_PADDING}
            textLength={17}
          >
            {maxPercent.toFixed(0)}
          </text>
        </svg>
      </div>
    );
  }
);

RadialTargetGraph.propTypes = {
  /**
   * Label for graph.
   */
  title: PropTypes.string,

  /**
   * Percentage value (between 0 and 1) for fill.
   */
  value: PropTypes.number.isRequired,

  /**
   * Target percentage (between 0 and 1) for target marker.
   */
  target: PropTypes.target,

  /**
   * Maximum percentage (between 0 and 1) for end of half circle.
   */
  max: PropTypes.number.isRequired,
};
